import { type RootState } from "~/app/store";
import { getWishlists } from "~/features/wishlist/redux/wishlistSelectors";

export const selectShareableWishlists = (state: RootState) => {
  return getWishlists(state.wishlistPage).filter((wishlist) => wishlist.entryIds.length > 0);
};
